export default __webpack_public_path__ + "static/floatingImg3-07550b663675122b5d7edd6980276ad0.webp";